import { Component, Inject, HostListener } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmDialogOptions } from "./confirm-dialog-options";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"]
})
export class ConfirmDialogComponent
{

  title: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogOptions
  )
  {
    this.title = data.title;
    this.message = data.message;
  }

  @HostListener("window:keyup.esc") handleEscapeKey()
  {
    this.handleNoClick();
  }

  @HostListener("window:keyup.enter") handleEnterKey()
  {
    this.handleYesClick();
  }

  public handleYesClick(): void
  {
    this.dialogRef.close(true);
  }

  public handleNoClick(): void
  {
    this.dialogRef.close(false);
  }

}
